/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegisterDevice200ResponseDevice } from './RegisterDevice200ResponseDevice';
import {
    RegisterDevice200ResponseDeviceFromJSON,
    RegisterDevice200ResponseDeviceFromJSONTyped,
    RegisterDevice200ResponseDeviceToJSON,
    RegisterDevice200ResponseDeviceToJSONTyped,
} from './RegisterDevice200ResponseDevice';

/**
 * 
 * @export
 * @interface RegisterDevice200Response
 */
export interface RegisterDevice200Response {
    /**
     * 
     * @type {boolean}
     * @memberof RegisterDevice200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterDevice200Response
     */
    message?: string;
    /**
     * 
     * @type {RegisterDevice200ResponseDevice}
     * @memberof RegisterDevice200Response
     */
    device?: RegisterDevice200ResponseDevice;
}

/**
 * Check if a given object implements the RegisterDevice200Response interface.
 */
export function instanceOfRegisterDevice200Response(value: object): value is RegisterDevice200Response {
    return true;
}

export function RegisterDevice200ResponseFromJSON(json: any): RegisterDevice200Response {
    return RegisterDevice200ResponseFromJSONTyped(json, false);
}

export function RegisterDevice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterDevice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'device': json['device'] == null ? undefined : RegisterDevice200ResponseDeviceFromJSON(json['device']),
    };
}

export function RegisterDevice200ResponseToJSON(json: any): RegisterDevice200Response {
    return RegisterDevice200ResponseToJSONTyped(json, false);
}

export function RegisterDevice200ResponseToJSONTyped(value?: RegisterDevice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'device': RegisterDevice200ResponseDeviceToJSON(value['device']),
    };
}

